import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { TitleStrategy, provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { rutasAplicacion } from './rutas/app-rutas';
import { cabecerasApiInterceptor } from './nucleo/interceptores/cabeceras-api-interceptor';
import { errorApiInterceptor } from './nucleo/interceptores/error-api-interceptor';
import { PresetTemaPortal } from './nucleo/tema/portal-tema.preset';
import { TRADUCCION_PRIMENG_ES } from './nucleo/tema/traduccion-primeng-es';
import { ManejadorErrorChunkUtil } from './nucleo/utilitarios/manejador-error-chunk-util';
import { IdiomaServicio } from './nucleo/i18n/idioma-servicio';
import { TituloPaginaEstrategia } from './nucleo/i18n/titulo-pagina-estrategia';

/**
 * Configuración raíz. `providePrimeNG` vive aquí (y solo aquí) porque registra el tema corporativo
 * que consumen los componentes de PrimeNG. `MessageService` alimenta los avisos (`p-toast`).
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(rutasAplicacion, withComponentInputBinding()),
    provideHttpClient(withInterceptors([cabecerasApiInterceptor, errorApiInterceptor])),
    providePrimeNG({
      theme: {
        preset: PresetTemaPortal,
        options: { darkModeSelector: false },
      },
      overlayAppendTo: 'body',
      translation: TRADUCCION_PRIMENG_ES,
    }),
    MessageService,
    { provide: ErrorHandler, useClass: ManejadorErrorChunkUtil },
    { provide: TitleStrategy, useExisting: TituloPaginaEstrategia },
    // Aplica el idioma inicial (PrimeNG y <html lang>) desde el arranque.
    provideAppInitializer(() => {
      inject(IdiomaServicio);
    }),
  ],
};
